<opac-popover #popover>
  <ul
    #element
    role="menu"
    (click)="handleClick($event)"
    (keydown)="handleKeydown($event)"
    (mousedown)="handleMousedown($event)"
    >
    <ng-content></ng-content>
  </ul>
</opac-popover>
